<template>
  <div class="header__dropdown-container-inner">
    <div class="header__dropdown-container-inner-featured-menu-links-container">
      <div class="header__dropdown-lists-container header__dropdown-list-menu-links-main-container">
        <ul
          class="header__dropdown-list header__dropdown-list-menu-links-container"
          v-for="(link, index) in block.link_list"
        >
          <li class="header__dropdown-list-links-image-container">
            <div class="mobile-header-dropdown-list-image-container" v-if="link.image">
              <img class="mobile-header-dropdown-list-image" :src="link.image" />
            </div>
            <div class="header-dropdown-list-links-container">
              <a class="header__dropdown-list-title preheader" :href="link.url">{{ link.title }}</a>
              <ul v-for="(child_link, index) in link.children">
                <li class="header__dropdown-list-item">
                  <a class="header__dropdown-link" :href="child_link.url">{{ child_link.title }}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="header__dropdown-lists-images-container">
      <h2><a class="header__dropdown-blog-link" href="/blogs/all">View all Blogs</a></h2>
      <div class="header__dropdown-lists-images-inner-container">
        <div
          class="header__dropdown-image-link-container"
          v-if="block.article_1"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <a :href="article_1_url_processed" >
                <img class="header__dropdown-image" :src="block.article_1.image.src" :alt="block.article_1.image.alt" />
              </a>
            </div>
            <div class="header-menu-image-title" v-if="block.article_1.title">
              {{ block.article_1.title }}
            </div>
            <v-link secondary :href="article_1_url_processed">Read &amp; Shop</v-link>
          </div>
        </div>
        <div class="header__dropdown-image-link-container" v-else>
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.article_1.image.src" :alt="block.article_1.image.alt" />
            </div>
            <div class="header-menu-image-title" v-if="block.article_1.title">{{ block.article_1.title }}</div>
          </div>
        </div>
        <a
          class="header__dropdown-image-link-container"
          v-if="block.article_2"
          :href="block.article_2_url_processed"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <a :href="article_2_url_processed">
              <img class="header__dropdown-image" :src="block.article_2.image.src" :alt="block.article_2.image.alt" />
              </a>
            </div>
            <div class="header-menu-image-title" v-if="block.article_2.title">
              {{ block.article_2.title }}
            </div>
            <v-link secondary :href="article_2_url_processed">Read &amp; Shop</v-link>
          </div>
        </a>
        <div class="header__dropdown-image-link-container" v-else>
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.article_2.image.src" :alt="block.article_2.image.alt" />
            </div>
            <div class="header-menu-image-title" v-if="block.article_2.title">{{ block.article_2.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-link
      class="header__menu-main-inner-link"
      v-if="block.url"
      secondary="secondary"
      :href="block.url"
    >Shop All</v-link> -->
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
import VLink from '../buttons/VLink.vue';
import ArrowButton from '../buttons/ArrowButton.vue';

export default {
  name: 'NavbarMobileTextSmallImageBlocks',
  components: { Icon, VLink, ArrowButton },
  props: {
    block: Object,
  },
  data() {
    return {
      article_1_url_processed: `/blogs/${this.block.article_1_url}`,
      article_2_url_processed: `/blogs/${this.block.article_2_url}`
    }
  },
};
</script>

<style scoped lang="scss">
.header__dropdown-container-inner {
  display: flex;
  flex-direction: column;
  padding: 35px 38px 52px;
}

.header__dropdown-side-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 32px;
}

.header__dropdown-list {
  margin-top: 0;
  margin-bottom: 0;
  padding: 20px 0;

  &:first-child {
    padding-top: 0;
  }

  @include desktop-up {
    margin-right: 78px;
  }
}

.header__close-button {
  position: absolute;
  top: 23px;
}

// .header__dropdown-featured-link {
//   font-size: 20px;
//   display: flex;
//   align-items: center;
//   margin-bottom: 24px;
//   color: $color-brand-primary;
// }

.mobile-header-menu-image-link-arrow {
  margin-left: 4px;
  color: $color-white;
}

.header__dropdown-list,
.header__dropdown-list ul {
  padding-left: 0;
  list-style: none;
}

.header__dropdown-list-title {
  display: block;
  text-decoration: none;
  margin-bottom: 24px;
  /* color: $color-text-black;
  text-decoration: none;
  font-weight: 500;
  @include body-lg; */
}

.header__dropdown-link {
  display: block;
  margin-bottom: 16px;
  color: $color-text-black;
  /* @include body-sm; */
  text-decoration: none;
  font-size: rem(28);
  line-height: rem(34);
  font-family: $font-family-primary;

    .link {
      font-family: $font-family-secondary;
    }
}

.header__dropdown-container-inner-featured-menu-links-container {
  @include desktop-up {
    width: 50%;
    display: flex;
  }
}

.mobile-header-dropdown-list-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 32px;
}

.header__dropdown-list-links-image-container {
  display: flex;
  flex-direction: row;
}

.header-dropdown-list-links-container {
  ul:last-child {
    .header__dropdown-link {
      margin-bottom: 0;
    }
  }
}

.header__dropdown-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;

  @include desktop-up {
    height: auto;
  }
}

.mobile-header-dropdown-list-image-container {
  display: block;

  @include desktop-up {
    display: none;
  }
}

.header__dropdown-lists-images-inner-container {
  margin-bottom: 33px;
  padding-top: 20px;
  position: relative;
  margin: 30px 0 0;
  padding-left: 0;

  @include desktop-up {
    margin: 90px 0 0;
  }
}

.header__dropdown-image-link-container {
  display: block;
  list-style: none;
  width: 100%;
  vertical-align: top;
  margin: 0 auto 30px;
  text-decoration: none;
  text-align: center;
  position: relative;
  text-align: center;

  .link {
    margin: 0 auto;
  }
}

.header__dropdown-image-link-inner-container {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
}

.header__dropdown-image-container {
  margin-bottom: 16px;
}

.header-menu-image-title {
  display: flex;
  align-items: center;
  color: $color-text-black;
  font-family: $font-family-primary;
  letter-spacing: rem(-0.1);
  font-size: rem(18);
  line-height: rem(23);
  text-align: center;
  justify-content: center;
  margin-bottom: 5px;

  @include tablet-up {
    font-size: rem(24);
    line-height: rem(31);
    text-align: left;
  }
}

.menu-image-link-arrow {
  margin-left: 4px;
  fill: $color-white;
  display: none;
}

.header__menu-main-inner-link {
  margin-top: 32px;
  color: $color-white;
}

.header__dropdown-blog-link {
  color: inherit;
  text-decoration: none;
}

</style>
